export async function downloadResumeAsPDF(text, jobTitle, company) {
  const html = `<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8"/>
<title>Resume – ${company}</title>
<style>
  body { font-family: Georgia, serif; max-width: 750px; margin: 40px auto; color: #1a1a2e; line-height: 1.7; font-size: 13px; }
  pre { white-space: pre-wrap; word-break: break-word; font-family: Georgia, serif; font-size: 13px; line-height: 1.7; }
  @media print { body { margin: 20px; } }
</style>
</head>
<body>
<pre>${text}</pre>
</body>
</html>`;
  const blob = new Blob([html], { type: "text/html" });
  const url = URL.createObjectURL(blob);
  const win = window.open(url, "_blank");
  if (win) {
    win.onload = () => {
      setTimeout(() => {
        win.print();
        URL.revokeObjectURL(url);
      }, 500);
    };
  }
}

export function downloadResumeAsDocx(text, jobTitle, company) {
  const safeText = text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
  const html = `
<html xmlns:o="urn:schemas-microsoft-com:office:office"
      xmlns:w="urn:schemas-microsoft-com:office:word"
      xmlns="http://www.w3.org/TR/REC-html40">
<head>
<meta charset="utf-8"/>
<meta name=ProgId content=Word.Document>
<meta name=Generator content="Microsoft Word 15">
<title>Resume – ${company}</title>
<style>
  body { font-family: Calibri, sans-serif; font-size: 11pt; line-height: 1.6; margin: 1in; color: #1a1a2e; }
  pre { font-family: Calibri, sans-serif; font-size: 11pt; white-space: pre-wrap; word-break: break-word; }
</style>
</head>
<body>
<pre>${safeText}</pre>
</body>
</html>`;
  const blob = new Blob(["\ufeff", html], { type: "application/msword" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `Resume_${company.replace(/\s+/g, "_")}_Tailored.doc`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
